import apiUrl from "../../../../constants";
import user_tracker from "../../../../usertracker";
import axios from "axios";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import Multiselect from "vue-multiselect";
import { BasicSelect } from "vue-search-select";

export default {
  name: "UpdateParentHub",
  components: {
    BasicSelect,
    VueElementLoading,
    Multiselect,
  },
  data: function () {
    return {
      useremail: "",
      cityList: [],
      groupList: [],
      parentHubList: [],
      allHubList: [],
      isLoading: false,
      cityLoading: "",

      // Form data
      destinationcityObjData: {
        value: "",
        text: "",
      },
      destinationcityid: "",
      destinationcityname: "",

      groupTypeObjData: {
        value: "",
        text: "",
      },
      groupid: "",
      groupDisplayName: "",
      groupno: "",

      currentParentHub: "",
      proposedParentHub: "",
      selectedRouteMode: [],

      // Validation
      cityError: "",
      groupError: "",
      currentParentHubError: "",
      proposedParentHubError: "",
      routeModeError: "",

      // Modals
      confirmationModal: false,

      // User data
      userData: [],
    };
  },

  created: function () {},

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem("userdetail");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userData = userdetail;
    this.useremail = userdetail[0].email;

    this.getCityList();
    this.getAllHubList();
  },

  methods: {
    // Get city list
    getCityList() {
      this.isLoading = false;
      this.cityLoading = "Loading City...";
      this.cityList = [];

      axios({
        method: "POST",
        url: apiUrl.api_url_hubops + "allcity/get",
        data: {},
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            var cityList = result.data.ResponseData;
            for (let i = 0; i < cityList.length; i++) {
              this.cityList.push({
                value: cityList[i].cityid,
                text: cityList[i].cityname,
              });
            }
          }
          this.isLoading = false;
          this.cityLoading = "";
        },
        (error) => {
          this.isLoading = false;
          this.cityLoading = "";
          console.error(error);
          this.$alert("Error loading cities", "", "error");
        }
      );
    },

    // Get all hub list for proposed parent hub dropdown
    getAllHubList() {
      axios({
				method: "POST",
				url: apiUrl.api_url_hubops + "expose/hubservicecenter/dropdwon/list",
				data: {},
				headers: {
					authorization: "authkey xB84JJ89Hd25"
				}
			}).then(
				(result) => {
					if (result.data.ResultCode == 100) {
						this.allHubList = result.data.ResponseData.map((hub) => ({
							hubid: hub.HubID,
							hubname: hub.HubName
						}));
					}
				},
				(error) => {
					console.error(error);
					this.$alert("Error loading hub list", "", "error");
				}
			);
    },

    // City selection handler
    selectedDestination(cityData) {
      this.clearErrors();
      this.resetGroupData();

      this.destinationcityObjData = cityData;
      this.destinationcityid = cityData.value;
      this.destinationcityname = cityData.text;

      if (this.destinationcityid != "") {
        this.getCitywiseGroups();
      }
    },

    // Get city wise groups
    getCitywiseGroups() {
      this.groupList = [];
      this.isLoading = true;

      axios({
        method: "GET",
        // legacy backup: getGroupfromCity
        // url:
        //   apiUrl.api_url_hubops +
        //   "getGroupfromCity?cityId=" +
        //   this.destinationcityid,
        url:
          apiUrl.api_url_hubops +
          "groups?cityId=" +
          this.destinationcityid +
          "&isActive=true",
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            var groupList = result.data.ResponseData;
            for (let i = 0; i < groupList.length; i++) {
              this.groupList.push({
                value: groupList[i].groupid,
                text:
                  groupList[i].groupname +
                  " - " +
                  groupList[i].routemode +
                  " - " +
                  groupList[i].groupno,
                groupno: groupList[i].groupno,
                routemode:groupList[i].routemode
              });
            }
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          console.error(error);
          this.$alert("Error loading groups", "", "error");
        }
      );
    },

    // Group selection handler
    selectedGroupType(groupTypeData) {
      this.clearErrors();
      this.resetParentHubData();

      this.groupTypeObjData = groupTypeData;
      this.groupid = groupTypeData.value;
      this.groupDisplayName = groupTypeData.text;
      this.groupno = groupTypeData.groupno;
      this.selectedRouteMode.push(groupTypeData.routemode)

      if (this.groupid != "") {
        this.getGroupParentHubDetails();
      }
    },

    // Get current parent hub details for selected group
    getGroupParentHubDetails() {
      this.isLoading = true;
      this.parentHubList = [];

      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops +
          "getGroupConnectionDetails?groupid=" +
          this.groupid +
          "&cityid=" +
          this.destinationcityid,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.parentHubList = result.data.ResponseData.parenthubs;

            // Auto-select if only one parent hub
            if (this.parentHubList.length == 1) {
              this.currentParentHub = this.parentHubList[0];
            }
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          console.error(error);
          this.$alert("Error loading parent hub details", "", "error");
        }
      );
    },


    // Current parent hub selection handler
    selectCurrentParentHub() {
      this.clearErrors();
    },

    // Proposed parent hub selection handler
    selectProposedParentHub() {
      this.clearErrors();
    },

    // Validation
    validateForm() {
      this.clearErrors();
      let isValid = true;

      if (!this.destinationcityid) {
        this.cityError = "City is required";
        isValid = false;
      }

      if (!this.groupid) {
        this.groupError = "Group is required";
        isValid = false;
      }

      if (!this.currentParentHub) {
        this.currentParentHubError = "Current Parent Hub is required";
        isValid = false;
      }

      if (!this.proposedParentHub) {
        this.proposedParentHubError = "Proposed Parent Hub is required";
        isValid = false;
      }

      if (!this.selectedRouteMode || this.selectedRouteMode.length === 0) {
        this.routeModeError = "Route Mode is required";
        isValid = false;
      }

      if (
        this.currentParentHub &&
        this.proposedParentHub &&
        this.currentParentHub.hubid === this.proposedParentHub.hubid
      ) {
        this.proposedParentHubError =
          "Proposed Parent Hub must be different from Current Parent Hub";
        isValid = false;
      }

      return isValid;
    },

    clearErrors() {
      this.cityError = "";
      this.groupError = "";
      this.currentParentHubError = "";
      this.proposedParentHubError = "";
      this.routeModeError = "";
    },

    onSubmitUpdateParentHub() {
      if (this.validateForm()) {
        this.confirmationModal = true;
      } else {
        window.scrollBy(0, -1000);
      }
    },

    confirmUpdateParentHub() {
      this.confirmationModal = false;
      this.isLoading = true;

      const payload = {
        groupno: this.groupno,
        currentParentHubId: this.currentParentHub.hubid,
        proposedParentHubId: this.proposedParentHub.hubid,
        routemode: this.selectedRouteMode,
        lastModifiedBy: this.useremail,
      };

      axios({
        method: "POST",
        url: apiUrl.api_url_hubops + "updateParentHubBulk",
        data: payload,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            user_tracker.checkUserIP(
              this.userData[0],
              "UpdateParentHub",
              this.$route.path,
              payload
            );
            this.resetForm();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        },
        (error) => {
          this.isLoading = false;
          console.error(error);
          this.$alert("Error updating parent hub", "", "error");
        }
      );
    },

    // Reset form
    resetForm() {
      this.destinationcityObjData = { value: "", text: "" };
      this.destinationcityid = "";
      this.destinationcityname = "";
      this.groupTypeObjData = { value: "", text: "" };
      this.groupid = "";
      this.groupDisplayName = "";
      this.groupno = "";
      this.currentParentHub = "";
      this.proposedParentHub = "";
      this.selectedRouteMode = [];
      this.groupList = [];
      this.parentHubList = [];
      this.clearErrors();
      this.confirmationModal = false;
    },
    //4549685756
    // Reset group-related data
    resetGroupData() {
      this.groupTypeObjData = { value: "", text: "" };
      this.groupid = "";
      this.groupDisplayName = "";
      this.groupno = "";
      this.groupList = [];
      this.resetParentHubData();
    },

    // Reset parent hub-related data
    resetParentHubData() {
      this.currentParentHub = "";
      this.proposedParentHub = "";
      this.selectedRouteMode = [];
      this.parentHubList = [];
    },

    // Close confirmation modal
    closeConfirmationModal() {
      this.confirmationModal = false;
    },
  },
};


// WEBPACK FOOTER //
// ./src/views/components/groupnew/UpdateParentHub/UpdateParentHub.js